import { hasCropEdits, outputSize, sourceRect } from "./imageAssets";

/* Turn a positioned image into the File that gets uploaded. */
export const CROP_TYPE = "image/png";

export const croppedFile = async ({
  file,
  image,
  spec,
  zoom,
  offset,
  frameWidth,
  frameHeight,
}) => {
  if (!file) return null;

  /* Untouched — hand back exactly what was chosen. */
  if (!hasCropEdits({ zoom, offset })) return file;

  const naturalWidth = image?.naturalWidth || image?.width;
  const naturalHeight = image?.naturalHeight || image?.height;

  /* Without real dimensions there is nothing to crop against; the original is
     the safe answer rather than a guess. */
  if (!naturalWidth || !naturalHeight || !frameWidth || !frameHeight) return file;

  const rect = sourceRect({
    zoom,
    offset,
    frameWidth,
    frameHeight,
    naturalWidth,
    naturalHeight,
  });
  const out = outputSize(spec, rect);

  const canvas = document.createElement("canvas");
  canvas.width = out.width;
  canvas.height = out.height;

  const ctx = canvas.getContext("2d");
  /* jsdom has no 2d context, and a browser can refuse one under memory
     pressure. Falling back to the original file is better than failing the
     upload. */
  if (!ctx) return file;

  ctx.drawImage(
    image,
    rect.x,
    rect.y,
    rect.width,
    rect.height,
    0,
    0,
    out.width,
    out.height
  );

  const blob = await new Promise((resolve) => {
    if (typeof canvas.toBlob !== "function") {
      resolve(null);
      return;
    }
    canvas.toBlob(resolve, CROP_TYPE);
  });

  if (!blob) return file;

  /* The name is kept so the stored object still carries something recognisable,
     with a .png extension because that is now what it is. */
  const base = String(file.name || "image").replace(/\.[^.]+$/, "");
  return new File([blob], `${base}.png`, { type: CROP_TYPE });
};

export default croppedFile;
